/**
 * Core Routes Configuration - OPTIMIZED WITH LAZY LOADING
 * Authentication and system routes with code splitting
 * Each page is loaded on-demand, reducing initial bundle size
 */
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

// LAZY LOAD all page components for code splitting
// System Pages
import Dashboard from '../pages/Dashboard';
import UsersPage from '../pages/UsersPage';
import NotificationsPage from '../pages/NotificationsPage';
import ActivityLogsPage from '../pages/ActivityLogsPage';
import RecycleBinPage from '../pages/RecycleBinPage';
import PurgeManagementPage from '../pages/PurgeManagementPage';

// Task Management
import TasksPage from '../pages/tasks/TasksPage';
import TaskDetailPage from '../pages/tasks/TaskDetailPage';
import TaskCalendarPage from '../pages/tasks/TaskCalendarPage';

// Settings
import BrandingSettingsPage from '../pages/BrandingSettingsPage';
import DemoSettingsPage from '../pages/DemoSettingsPage';
import BankChannelsPage from '../pages/settings/BankChannelsPage';
import FiscalPeriodsPage from '../pages/settings/FiscalPeriodsPage';
import TaxSettingsPage from '../pages/settings/TaxSettingsPage';
import AccountSettingsPage from '../pages/settings/AccountSettingsPage';
import SecuritySettingsPage from '../pages/settings/SecuritySettingsPage';
import WhatsAppSettingsPage from '../pages/wholesale/settings/WhatsAppSettingsPage';

/**
 * Core protected routes (dashboard, users, notifications, tasks, settings)
 * Lazy-loaded components - Suspense is handled at the App/Layout level
 */
export const coreRoutes = (
  <>
    {/* Root redirect */}
    <Route path="/" element={<Navigate to="/retail/dashboard" replace />} />
    <Route path="/dashboard" element={<Navigate to="/retail/dashboard" replace />} />

    {/* Main Dashboard */}
    <Route path="/retail/dashboard" element={<Dashboard />} />

    {/* User Management */}
    <Route path="/users" element={<UsersPage />} />

    {/* Notifications */}
    <Route path="/notifications" element={<NotificationsPage />} />

    {/* Activity Logs */}
    <Route path="/activity-logs" element={<ActivityLogsPage />} />

    {/* Recycle Bin */}
    <Route path="/recycle-bin" element={<RecycleBinPage />} />
    <Route path="/purge-management" element={<PurgeManagementPage />} />

    {/* Task Management */}
    <Route path="/tasks" element={<TasksPage />} />
    <Route path="/tasks/calendar" element={<TaskCalendarPage />} />
    <Route path="/tasks/:id" element={<TaskDetailPage />} />

    {/* Settings */}
    <Route
      path="/settings/branding"
      element={
        <ProtectedRoute allowedRoles={['admin', 'super_admin', 'system_admin']}>
          <BrandingSettingsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/settings/demo"
      element={
        <ProtectedRoute allowedRoles={['super_admin', 'system_admin']}>
          <DemoSettingsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/settings/bank-channels"
      element={
        <ProtectedRoute allowedRoles={['admin', 'super_admin', 'system_admin']}>
          <BankChannelsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/settings/fiscal-periods"
      element={
        <ProtectedRoute allowedRoles={['admin', 'super_admin', 'system_admin']}>
          <FiscalPeriodsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/settings/tax"
      element={
        <ProtectedRoute allowedRoles={['admin', 'super_admin', 'system_admin']}>
          <TaxSettingsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/settings/account"
      element={
        <ProtectedRoute allowedRoles={['super_admin', 'system_admin']}>
          <AccountSettingsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/settings/security"
      element={
        <ProtectedRoute allowedRoles={['super_admin', 'system_admin']}>
          <SecuritySettingsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/settings/whatsapp"
      element={
        <ProtectedRoute allowedRoles={['admin', 'super_admin', 'system_admin', 'retail_admin']}>
          <WhatsAppSettingsPage />
        </ProtectedRoute>
      }
    />
  </>
);

export default { coreRoutes };
